module.exports = __webpack_public_path__ + "img/turtle.5eb52764.svg";